export const complexLevel = [
  {
    _id: 1,
    name: "High",
  },
  {
    _id: 2,
    name: "Medium",
  },
  {
    _id: 3,
    name: "Low",
  },
  {
    _id: 4,
    name: "Complex",
  },
];

export const inputTypeText = {
  descType: "text",
  description: "",
};

export const inputTypeImage = {
  descType: "img",
  description: "",
};

export const inputTypeVideo = {
  descType: "video",
  description: "",
};

export const optionTypeText = {
  descType: "text",
  description: "",
  isCorrect: false,
};
export const optionTypeImage = {
  descType: "img",
  description: "",
  isCorrect: false,
};

export const examTypesList = [
  {
    _id: 1,
    name: "Unit Test",
  },
  {
    _id: 2,
    name: "Mock Test",
  },
  {
    _id: 3,
    name: "Sub Topic Test",
  },
  {
    _id: 4,
    name: "PYQ",
  },
  {
    _id: 5,
    name: "Scholarship Test",
  },
  {
    _id: 6,
    name: "Sunday Batch Test",
  },
  {
    _id: 7,
    name: "Webinar",
  },
  {
    _id: 8,
    name: "Topic Test",
  },
];

export const examTypes = [
  {
    _id: "1",
    name: "Unit Test",
  },
  {
    _id: "2",
    name: "Mock Test",
  },
  {
    _id: "3",
    name: "TOPIC TEST",
  },
  {
    _id: "6",
    name: "Sunday Test",
  },
  {
    _id: "4",
    name: "PYQ",
  },
];

export const examTypesFree = [
  {
    _id: "1",
    name: "Unit Test",
  },
  {
    _id: "2",
    name: "Mock Test",
  },
  {
    _id: 3,
    name: "Sub Topic Test",
  },
  {
    _id: "4",
    name: "PYQ",
  },
  {
    _id: "5",
    name: "Scholarship Test",
  },

  {
    _id: 7,
    name: "Webinar",
  },
  {
    _id: 8,
    name: "Topic Test",
  },
];

// For Dropdown Default State
export const defaultVal = {
  _id: "",
  name: "Please Select",
};

export const DecimalList = [
  {
    name: "N/A",
    _id: 0,
  },
  {
    name: "One Decimal",
    _id: 1,
  },
  {
    name: "Two Decimal",
    _id: 2,
  },
  {
    name: "Three Decimal",
    _id: 3,
  },
];

export const initialVal = {
  subCategoryId: "",
  booksPackageId: "",
  bookList: [],
  subscriptionPlan: [
    {
      durationId: "",
      months: 0,
      price: 0,
      isRecommended: false,
    },
  ],
  isOffer: false,
  offer: "",
  isFreeTrial: false,
  trialDuration: "",
};

export const initialSubCategoryVal = {
  subCategoryId: "",
  subCategoryData: {},
};

export const initialValSM = {
  subCategoryId: "",
  booksPackageId: "",
  bookListSM: [],
  packagebooksSellType: 0,
  books: [
    {
      bannerImage: "",
      price: 0,
      sellPrice: 0,
      name: "",
      booksList: [""],
      bookId: "",
    },
  ],
  comboArray: [
    {
      bannerImage: null,
      price: 0,
      sellPrice: 0,
      name: "",
      booksList: [],
    },
  ],
  isOffer: false,
  offer: "",
  isFreeTrial: false,
  trialDuration: "",
};

export const porderData = [
  {
    _id: "1",
    name: 1,
  },
  {
    _id: "2",
    name: 2,
  },
  {
    _id: "3",
    name: 3,
  },
  {
    _id: "4",
    name: 4,
  },
  {
    _id: "5",
    name: 5,
  },
  {
    _id: "6",
    name: 6,
  },
  {
    _id: "7",
    name: 7,
  },
  {
    _id: "8",
    name: 8,
  },
  {
    _id: "9",
    name: 9,
  },
  {
    _id: "10",
    name: 10,
  },
  {
    _id: "11",
    name: 11,
  },
  {
    _id: "12",
    name: 12,
  },
  {
    _id: "13",
    name: 13,
  },
  {
    _id: "14",
    name: 14,
  },
  {
    _id: "15",
    name: 15,
  },
  {
    _id: "16",
    name: 16,
  },
  {
    _id: "17",
    name: 17,
  },
  {
    _id: "18",
    name: 18,
  },
  {
    _id: "19",
    name: 19,
  },
  {
    _id: "20",
    name: 20,
  },
];
export const data = [
  {
    name: "Yes",
    _id: true,
  },
  {
    name: "No",
    _id: false,
  },
];

export const statusActive = [
  {
    name: "Yes",
    _id: 1,
  },
  {
    name: "No",
    _id: 0,
  },
];

export const defaultSubscription = {
  subCategoryId: "",
  booksPackageId: "",
  bookList: [],
  subscriptionPlan: [
    {
      durationId: "",
      months: 0,
      price: 0,
      isRecommended: false,
    },
  ],
};

export const defaultStudyMaterial = {
  subCategoryId: "",
  booksPackageId: "",
  bookListSM: [],
  packagebooksSellType: 0,
  books: [
    {
      bannerImage: "",
      price: 0,
      sellPrice: 0,
      name: "",
      booksList: [""],
      bookId: "",
    },
  ],
  comboArray: [
    {
      bannerImage: null,
      price: 0,
      sellPrice: 0,
      name: "",
      booksList: [],
    },
  ],
};

export const lectureTypeList = [
  {
    _id: 1,
    name: "Live lecture",
  },
  {
    _id: 2,
    name: "Recorded lecture",
  },
  {
    _id: 3,
    name: "Test series",
  },
  {
    _id: 4,
    name: "Book",
  },
  {
    _id: 5,
    name: "Youtube Live",
  },
];

export const categoryList = [
  {
    _id: 1,
    name: "Batch Support",
  },
  // {
  //   _id: 2,
  //   name: "General Support",
  // },
  {
    _id: 3,
    name: "Infra Support",
  },
];

export const SMCategoryList = [
  {
    _id: 1,
    name: "ONLINE CLASS",
  },
  {
    _id: 2,
    name: "STUDY MATERIAL",
  },
];

export const ShipmentStatusList = [
  {
    _id: 0,
    name: "Pending",
  },
  {
    _id: 1,
    name: "Partial Dispatched",
  },
  {
    _id: 2,
    name: "Complete Dispatched",
  },
  {
    _id: 3,
    name: "Returned",
  },
  {
    _id: 4,
    name: "Delievered",
  },
];

export const trackingStatusList = [
  {
    _id: 0,
    name: "Pending",
  },
  {
    _id: 1,
    name: "Partial Dispatched",
  },
  {
    _id: 2,
    name: "Complete Dispatched",
  },
  {
    _id: 3,
    name: "Returned",
  },
  {
    _id: 4,
    name: "Delievered",
  },
];

export const BookStatusList = [
  {
    _id: 1,
    name: "All",
  },
  {
    _id: 2,
    name: "Available",
  },
  {
    _id: 3,
    name: "Out Of Stock",
  },
];

export const monthData = [
  {
    _id: 1,
    value: 1,
    name: "January",
  },
  {
    _id: 2,
    value: 2,
    name: "February",
  },
  {
    _id: 3,
    value: 3,
    name: "March",
  },
  {
    _id: 4,
    value: 4,
    name: "April",
  },
  {
    _id: 5,
    value: 5,
    name: "May",
  },
  {
    _id: 6,
    value: 6,
    name: "June",
  },
  {
    _id: 7,
    value: 7,
    name: "July",
  },
  {
    _id: 8,
    value: 8,
    name: "August",
  },
  {
    _id: 9,
    value: 9,
    name: "September",
  },
  {
    _id: 10,
    value: 10,
    name: "October",
  },
  {
    _id: 11,
    value: 11,
    name: "November",
  },
  {
    _id: 12,
    value: 12,
    name: "December",
  },
];

export const yearData = [
  {
    _id: 2026,
    value: 2026,
    name: "2026",
  },
  {
    _id: 2025,
    value: 2025,
    name: "2025",
  },
  {
    _id: 2024,
    value: 2024,
    name: "2024",
  },
  {
    _id: 2023,
    value: 2023,
    name: "2023",
  },
  {
    _id: 2022,
    value: 2022,
    name: "2022",
  },
  {
    _id: 2021,
    value: 2021,
    name: "2021",
  },
  {
    _id: 2020,
    value: 2020,
    name: "2020",
  },
];

export const yearData1 = [
  { _id: 2026, value: 2026, name: "2026" },
  { _id: 2025, value: 2025, name: "2025" },
  { _id: 2024, value: 2024, name: "2024" },
  { _id: 2023, value: 2023, name: "2023" },
  { _id: 2022, value: 2022, name: "2022" },
  { _id: 2021, value: 2021, name: "2021" },
  { _id: 2020, value: 2020, name: "2020" },
  { _id: 2019, value: 2019, name: "2019" },
  { _id: 2018, value: 2018, name: "2018" },
  { _id: 2017, value: 2017, name: "2017" },
  { _id: 2016, value: 2016, name: "2016" },
  { _id: 2015, value: 2015, name: "2015" },
  { _id: 2014, value: 2014, name: "2014" },
  { _id: 2013, value: 2013, name: "2013" },
  { _id: 2012, value: 2012, name: "2012" },
  { _id: 2011, value: 2011, name: "2011" },
  { _id: 2010, value: 2010, name: "2010" },
  { _id: 2009, value: 2009, name: "2009" },
  { _id: 2008, value: 2008, name: "2008" },
  { _id: 2007, value: 2007, name: "2007" },
  { _id: 2006, value: 2006, name: "2006" },
  { _id: 2005, value: 2005, name: "2005" },
  { _id: 2004, value: 2004, name: "2004" },
  { _id: 2003, value: 2003, name: "2003" },
  { _id: 2002, value: 2002, name: "2002" },
  { _id: 2001, value: 2001, name: "2001" },
  { _id: 2000, value: 2000, name: "2000" },
];

export const defaultDuration = "00:00";
export const defaultDurationTime = "00:00:00";

export const getTableDataSlots = (count) => {
  const slotsArray = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 200, label: 200 },
    { value: count, label: "All" },
  ];

  return slotsArray;
};

export const technicalSupportTypeList = [
  {
    _id: 0,
    name: "All",
  },
  {
    _id: 1,
    name: "App Related",
  },
  {
    _id: 2,
    name: "Course Related",
  },
];

export const priorityOrderData = [
  {
    _id: 0,
    name: "Low",
  },
  {
    _id: 1,
    name: "Medium",
  },
  {
    _id: 2,
    name: "High",
  },
];

export const notificationTypeData = [
  {
    _id: 1,
    name: "Class Schedule",
  },
];

export const taskTypeList = [
  {
    _id: 1,
    name: "PAID APP LIVE",
    value: "PAID_APP_LIVE",
  },
  {
    _id: 2,
    name: "YOUTUBE LIVE",
    value: "YOUTUBE_LIVE",
  },
  {
    _id: 3,
    name: "FREE APP LIVE",
    value: "FREE_APP_LIVE",
  },
  {
    _id: 4,
    name: "OFFLINE",
    value: "OFFLINE",
  },
  {
    _id: 5,
    name: "TEST SERIES DISCUSSION",
    value: "TEST_SERIES_DISCUSSION",
  },
  {
    _id: 6,
    name: "BOOK REVIEW",
    value: "BOOK_REVIEW",
  },
  {
    _id: 7,
    name: "ANNOUNCEMENT VIDEO",
    value: "ANNOUNCEMENT_VIDEO",
  },
  {
    _id: 8,
    name: "WEBINAR",
    value: "WEBINAR",
  },
  {
    _id: 9,
    name: "NOTIFICATION",
    value: "NOTIFICATION",
  },
  {
    _id: 10,
    name: "CONCEPT VIDEO",
    value: "CONCEPT_VIDEO",
  },
  {
    _id: 11,
    name: "OFF TOPIC VIDEO",
    value: "OFF_TOPIC",
  },
  {
    _id: 12,
    name: "INTERVIEW",
    value: "INTERVIEW",
  },
  {
    _id: 13,
    name: "PAID APP RECORDED",
    value: "PAID_APP_RECORDED",
  },
  {
    _id: 14,
    name: "QUESTIONS MAKING",
    value: "QUESTIONS_MAKING",
  },
  {
    _id: 15,
    name: "PYQ SORTING",
    value: "PYQ_SORTING",
  },
  {
    _id: 16,
    name: "PYQ PAPER ANALYSIS",
    value: "PYQ_PAPER_ANALYSIS",
  },
];

export const taskStatusList = [
  {
    _id: 1,
    name: "PENDING",
  },
  {
    _id: 2,
    name: "COMPLETE",
  },
  {
    _id: 3,
    name: "MISCELLANEOUS",
  },
  {
    _id: 4,
    name: "ON LEAVE",
  },
  {
    _id: 5,
    name: "NOT COMPLETED",
  },
];

export const SOP_PPT_List = [
  {
    _id: 1,
    name: "SOP",
  },
  {
    _id: 2,
    name: "PPT FOR PEN DISPLAY",
  },
  {
    _id: 3,
    name: "PPT FOR SMART BOARD",
  },
];

export const tokenTypeList = [
  {
    _id: 1,
    name: "DATA ENTRY",
    value: "DATA_ENTRY",
  },
  {
    _id: 2,
    name: "FACULTY",
    value: "FACULTY",
  },
  {
    _id: 3,
    name: "QUERY INFORMATIVE",
    value: "QUERY_INFORMATIVE",
  },
  {
    _id: 4,
    name: "QUERY SYLLABUS",
    value: "QUERY_SYLLABUS",
  },
  {
    _id: 5,
    name: "QUERY ENQUIRY",
    value: "QUERY_ENQUIRY",
  },
  {
    _id: 6,
    name: "TECHNICAL IOS",
    value: "TECHNICAL_IOS",
  },
  {
    _id: 7,
    name: "TECHNICAL ANDROID",
    value: "TECHNICAL_ANDROID",
  },
  {
    _id: 8,
    name: "TECHNICAL EXE",
    value: "TECHNICAL_EXE",
  },
  {
    _id: 9,
    name: "OTHER",
    value: "OTHER",
  },
];

export const companyNameList = [
  {
    _id: 1,
    name: "IFAS EDUTECH",
    value: "IFAS_EDUTECH",
  },
  {
    _id: 2,
    name: "IFAS OFFLINE PUNE",
    value: "IFAS_OFFLINE_PUNE",
  },
  {
    _id: 3,
    name: "IFAS OFFLINE JODHPUR",
    value: "IFAS_OFFLINE_JODHPUR",
  },
  {
    _id: 4,
    name: "IFAS PUBLICATIONS",
    value: "IFAS_PUBLICATIONS",
  },
];

export const regionList = [
  {
    _id: 1,
    name: "ap-south-1",
  },
  {
    _id: 2,
    name: "us-east-1",
  },
];

export const envList = [
  {
    _id: 1,
    name: "IFAS",
  },
  {
    _id: 2,
    name: "DHISTER",
  },
  {
    _id: 3,
    name: "LURNIGO",
  },
  {
    _id: 4,
    name: "RASHMII",
  },
];

export const instanceList = [
  {
    _id: 1,
    name: "BBB RTMP SERVER",
    value: "i-0de7211d7f307f8ca",
  },
];

export const examTypeQuestionBank = [
  {
    _id: 1,
    name: "MCQ",
  },
  {
    _id: 2,
    name: "MSQ",
  },
  {
    _id: 3,
    name: "NAT",
  },
  {
    _id: 4,
    name: "Assertion",
  },
];

export const priorityOrderQuestion = [
  {
    _id: 1,
    name: "Low",
  },
  {
    _id: 2,
    name: "Medium",
  },
  {
    _id: 3,
    name: "High",
  },
];

export const monthDataWithNotSelected = [
  {
    _id: "",
    value: "",
    name: "Not Selected",
  },
  {
    _id: 1,
    value: 1,
    name: "January",
  },
  {
    _id: 2,
    value: 2,
    name: "February",
  },
  {
    _id: 3,
    value: 3,
    name: "March",
  },
  {
    _id: 4,
    value: 4,
    name: "April",
  },
  {
    _id: 5,
    value: 5,
    name: "May",
  },
  {
    _id: 6,
    value: 6,
    name: "June",
  },
  {
    _id: 7,
    value: 7,
    name: "July",
  },
  {
    _id: 8,
    value: 8,
    name: "August",
  },
  {
    _id: 9,
    value: 9,
    name: "September",
  },
  {
    _id: 10,
    value: 10,
    name: "October",
  },
  {
    _id: 11,
    value: 11,
    name: "November",
  },
  {
    _id: 12,
    value: 12,
    name: "December",
  },
];

export const holidays = [
  "2026-01-01", // New Year
  "2026-01-26", // Republic Day
  "2026-03-04", // Holi
  "2026-05-01", // Labor Day / Maharashtra Day
  "2026-08-15", // Independence Day
  "2026-08-28", // Raksha Bandhan
  "2026-09-25", // Ganesh Visarjan
  "2026-10-02", // Gandhi Jayanti
  "2026-10-20", // Dussehra
  "2026-11-09", // Diwali
  "2026-11-10", // Diwali
  "2026-12-25", // Christmas
];

export const sourceData = [
  {
    _id: 3,
    name: "Website",
  },
  {
    _id: 1,
    name: "Classroom",
  },
  {
    _id: 4,
    name: "Webinar",
  },
  {
    _id: 8,
    name: "Social Media",
  },
  {
    _id: 6,
    name: "Ad Marketing",
  },
  {
    _id: 13,
    name: "App Registration",
  },
];
export const RoleList = [
  {
    _id: 14,
    name: "SOCIAL MEDIA",
  },
  {
    _id: 2,
    name: "CATEGORY",
  },
];

export const youtubeTypeList = [
  {
    _id: 1,
    name: "Videos",
  },
  {
    _id: 2,
    name: "Live",
  },
  {
    _id: 3,
    name: "Shorts",
  },
];

export const ResultOtherDetails = [
  {
    _id: 1,
    name: "JRF",
  },
  {
    _id: 2,
    name: "NET LS",
  },
  {
    _id: 3,
    name: "PHD",
  },
];

export const transactionTypeList = [
  { _id: 1, name: "Edutech", value: false },
  { _id: 2, name: "Publication", value: true },
  { _id: 3, name: "Shopify", value: false },
];

export const categoryListData = [
  {
    _id: 1,
    name: "UNRESERVED",
  },
  {
    _id: 2,
    name: "EWS",
  },
  {
    _id: 3,
    name: "OBS",
  },
  {
    _id: 4,
    name: "PWD",
  },
];

export const ScoreCardList = [
  {
    _id: 1,
    name: "Image",
  },
  {
    _id: 2,
    name: "PDF",
  },
];

export const LectureNum = [
  { name: 1 },
  { name: 2 },
  { name: 3 },
  { name: 4 },
  { name: 5 },
  { name: 6 },
  { name: 7 },
];
export const reportTypeList = [
  {
    _id: 1,
    name: "Edutech Transaction",
    subkey: "",
  },
  {
    _id: 2,
    name: "Edutech Extended",
    subkey: "extendedOption",
  },
  {
    _id: 3,
    name: "Edutech Upgrade",
    subkey: "upgradePackageOption",
  },
  {
    _id: 4,
    name: "Edutech Study Material",
    subkey: "studyMaterial",
  },
  {
    _id: 5,
    name: "Edutech Transaction + Extended + Upgrade",
    subkey: "allTransactionData",
  },
  {
    _id: 6,
    name: "Publication Transaction",
    subkey: "publication",
  },
  {
    _id: 7,
    name: "Edutech in Publication ",
    subkey: "paymentInPublication",
  },
];

export const TypeList = [
  {
    _id: 1,
    name: "Transaction",
  },
  {
    _id: 2,
    name: "Extended",
  },
  {
    _id: 3,
    name: "Upgrade",
  },
];

export const ReportsTabList = [
  {
    _id: 1,
    name: "Overview",
  },
  {
    _id: 2,
    name: "Download",
  },
];

export const statusActiveDeactiveDeleted = [
  {
    _id: 1,
    name: "Active",
  },
  {
    _id: 9,
    name: "Deleted",
  },
];

export const deviceAddStatusList = [
  { _id: 1, name: "Available" },
  { _id: 6, name: "Office Use" },
  { _id: 7, name: "Studio Use" },
];

export const deviceStatusList = [
  { _id: 1, name: "Available" },
  { _id: 2, name: "Assigned" },
  { _id: 3, name: "Damaged" },
  { _id: 4, name: "Repair" },
  { _id: 5, name: "Dead" },
  { _id: 6, name: "Office Use" },
  { _id: 7, name: "Studio Use" },
];
// export const paymentOptions = [
//   { _id: 0, name: "DEFAULT (Without Coupon Code)" },
//   { _id: 1, name: "IFAS COUPON CODE" },
//   { _id: 2, name: "STUDENT" },
//   { _id: 3, name: "EDUTECH COUNSELLOR" },
//   { _id: 4, name: "PAMPHLET" },
//   { _id: 5, name: "SHOPIFY" },
//   { _id: 6, name: "PUBLICATION COUNSELLOR" },
// ];
export const paymentOptions = [
  { _id: 0, name: "DEFAULT" },
  { _id: 1, name: "IFAS" },
  { _id: 2, name: "STUDENT" },
  { _id: 3, name: "EDUTECH COUNSELLOR" },
  { _id: 4, name: "PAMPHLET" },
  { _id: 5, name: "SHOPIFY" },
  { _id: 6, name: "PUBLICATION COUNSELLOR" },
  { _id: 7, name: "INFLUENCER" },
  { _id: 8, name: "REFER" },
  { _id: 9, name: "TEACHER" },
  { _id: 10, name: "CRACKKARO" },
  { _id: 11, name: "SERVICE TEAM" },
  { _id: 12, name: "AMAZON SELLING" },
];

export const mediaList = [
  {
    _id: "facebook_page",
    name: "FB Page",
  },
  {
    _id: "facebook_group",
    name: "FB Group",
  },
  {
    _id: "instagram",
    name: "Instagram",
  },
  {
    _id: "youtube",
    name: "YouTube",
  },
  {
    _id: "telegram_channel",
    name: "Telegram Channel",
  },
  {
    _id: "telegram_group",
    name: "Telegram Group",
  },
];

export const resultGivenByList = [
  {
    _id: 1,
    name: "Default",
  },
  {
    _id: 2,
    name: "Counsellor",
  },
];

export const taskStatus = [
  {
    _id: 1,
    name: "In Progress",
  },
  {
    _id: 2,
    name: "Pending",
  },
  {
    _id: 3,
    name: "Done",
  },
];
export const originSourceList = [
  {
    _id: 1,
    name: "Youtube",
  },
  {
    _id: 2,
    name: "Whatsapp",
  },
  {
    _id: 3,
    name: "Instagram",
  },
  {
    _id: 4,
    name: "Facebook",
  },
  {
    _id: 5,
    name: "Telegram",
  },
  {
    _id: 6,
    name: "Friend",
  },
  {
    _id: 7,
    name: "Teachers",
  },
  {
    _id: 8,
    name: "Other",
  },
];

export const genderData = [
  {
    _id: 1,
    name: "MALE",
  },
  {
    _id: 2,
    name: "FEMALE",
  },
  {
    _id: 3,
    name: "OTHER",
  },
];

export const employeeTypeData = [
  {
    _id: 1,
    name: "Professional",
  },
  {
    _id: 2,
    name: "Employee",
  },
];

export const educationalData = [
  {
    _id: 1,
    name: "10th",
  },
  {
    _id: 2,
    name: "12th",
  },
  {
    _id: 3,
    name: "Graduation",
  },
  {
    _id: 4,
    name: "Post Graduation",
  },
  {
    _id: 5,
    name: "PHD",
  },
  {
    _id: 6,
    name: "Diploma",
  },
];

export const gstRateList = [
  {
    id: 1,
    name: 0,
  },
  {
    id: 2,
    name: 5,
  },
  {
    id: 3,
    name: 12,
  },
  {
    id: 4,
    name: 18,
  },
  {
    id: 5,
    name: 28,
  },
];

export const stockTransferType = [
  { _id: 1, name: "Sell" },
  { _id: 2, name: "Shift" },
];
export const stockSellingType = [
  { _id: 1, name: "In House Publication", value: "publication-inhouse" },
  { _id: 2, name: "WareHouse Publication", value: "publication-warehouse" },
  { _id: 3, name: "In House Two Brothers", value: "twobrothers-inhouse" },
  { _id: 4, name: "WareHouse Two Brothers", value: "twobrothers-warehouse" },
];

export const stockShiftingType = [
  { _id: 1, name: "WareHouse Publication", value: "publication-warehouse" },
  { _id: 2, name: "In House Two Brothers", value: "twobrothers-inhouse" },
  { _id: 3, name: "WareHouse Two Brothers", value: "twobrothers-warehouse" },
];

export const stockReturnType = [
  { _id: 1, name: "Order return to" },
  // { _id: 2, name: "Shift to InHouse" },
];
export const stockShiftType = [
  { _id: 2, name: "Shift to Warehouse" },
  { _id: 1, name: "Shift to InHouse" },
];
export const couponSourceData = [
  { _id: 1, name: "WhatsApp" },
  { _id: 2, name: "Email" },
  { _id: 2, name: "Notification" },
  { _id: 2, name: "PopUp" },
];
export const language = [
  { _id: "6434e85b8fb2f655c0e657f8", name: "HINGLISH" },
  { _id: "6434e8698fb2f655c0e65807", name: "ENGLISH" },
];
export const AllPopupData = [
  { _id: "UPGRADE", name: "UPGRADE" },
  { _id: "EXTEND", name: "EXTEND" },
  { _id: "CROSS SELLING", name: "CROSS SELLING" },
  { _id: "STUDENT", name: "STUDENT" },
  { _id: "BIRTHDAY", name: "BIRTHDAY" },
  { _id: "STUDENT 2ND", name: "STUDENT 2ND" },
  { _id: "SPECIAL OFFER", name: "SPECIAL OFFER" },
  { _id: "EXAM WISE", name: "EXAM WISE" },
];
export const DemoGraphicsOption = [
  {
    _id: 1,
    name: "GENDER",
    value: "gender",
  },
  {
    _id: 2,
    name: "HAS ACTIVE PLAN",
    value: "hasActivePlan",
  },
  {
    _id: 3,
    name: "STATUS",
    value: "status",
  },
  {
    _id: 4,
    name: "IS KYC COMPLETED",
    value: "isKycCompleted",
  },
  {
    _id: 5,
    name: "EMAIL VERIFIED",
    value: "emailVerified",
  },
  {
    _id: 6,
    name: "WHATSAPP SHOOT STATUS",
    value: "whatsAppShootStatus",
  },
  {
    _id: 7,
    name: "SOURCE",
    value: "source",
  },
  {
    _id: 8,
    name: "WHATSAPP VERIFIED",
    value: "whatsAppVerified",
  },
  {
    _id: 9,
    name: "STATE",
    value: "state",
  },
  {
    _id: 10,
    name: "QUALIFICATION",
    value: "qualification",
  },
];
